<template>
  <div class="security-status" :class="statusClass">
    <div>
      {{ status }}  
    </div>
  </div>
</template>

<script>
import {computed} from 'vue'

export default {
  name: 'trip-status-label',
  props: ['status'],
  setup(props) {
    const statusList = {
      'Назначен исполнитель': 'partially-verified',
      'Выезд разрешен': 'success',
      'Выезд запрещен': 'warning',
      'Новый': 'new',
      'В работе': 'work',
      'В пути': 'success',
      'Открыт повторно':'reopen',
      'Закрыт':'close'
    };

    const statusClass = computed(() => {
      const status = statusList[props.status];
      return status || 'unknown-status';
    });

    return {
      statusClass,
    };
  },
};
</script>

<style scoped>
.security-status{
  min-width: 100px;
  font-size: 11px;
  border-radius: 4px;
  padding: 5px;
}

.work{
  background-color: #4f4da8;
  color: white;
}

.reopen{
  background-color: #fd636b
}

.close{
  background-color: #272727;
  color: white;
}

.neutral {
  background-color: #f0ad4e; /* Желтый */
  color: #000; /* Черный */
}

.new {
  background-color: #007bff; /* Синий */
  color: #fff; /* Белый */
}

.partially-verified {
  background-color: #ffc107; /* Оранжевый */
  color: #000; /* Черный */
}

.success {
  background-color: #28a745; /* Зеленый */
  color: #fff; /* Белый */
}

.warning {
  background-color: #dc3545; /* Красный */
  color: #fff; /* Белый */
}

.unknown-status {
  background-color: #888; /* Серый */
  color: #fff; /* Белый */
}
</style>
